<template>
  <section id="account" :class="{ 'notLogged': !loggedIn}">
    <div id="pageContent">
      <h1>Ihr Account</h1>
      <template v-if="loggedIn">
        <hint :condition="!currentUser.verified">Bevor Sie weitere Einstellungen vornehmen können, müssen Sie Ihre E-Mail-Adresse bestätigen. Sehen Sie bitte auch in Ihrem Spam-Ordner nach.</hint>
      </template>
      <section class="tile">
        <header>
          <h2>Profil</h2>
          <template v-if="currentUser.verified">
            <button v-if="!editMode" @click="toggleEditMode()">Bearbeiten</button>
            <span v-else class="button-group">
              <button @click="toggleEditMode('cancel')">Abbrechen</button>
              <button @click="updateProfile()">Speichern</button>
            </span>
          </template>
        </header>
        <template v-if="!editMode">
          <main class="account">
            <template v-if="currentUser.userData.userName !== ''">
              <p class="primary-data">{{currentUser.userData.userName}}</p>
              <p v-if="currentUser.userData.companyName !== ''">{{currentUser.userData.companyName}}<span v-if="currentUser.userData.companyLegal !== ''" class="secondary-data"> {{currentUser.userData.companyLegal}}</span></p>
            </template>
            <template v-else>
              <p v-if="currentUser.userData.companyName !== ''" class="primary-data">{{currentUser.userData.companyName}}<span v-if="currentUser.userData.companyLegal !== ''" class="secondary-data"> {{currentUser.userData.companyLegal}}</span></p>
              <br>
            </template>
            <p v-if="currentUser.userData.mail !== ''">{{currentUser.userData.mail}}</p>
            <p v-if="currentUser.userData.phone !== ''">{{currentUser.userData.phone}}</p>
            <p class="secondary-data">{{currentUser.userData.addressStreet}}<br v-if="currentUser.userData.addressAddition !== ''">{{currentUser.userData.addressAddition}}<br v-if="currentUser.userData.addressZip !== '' || currentUser.userData.addressLocation !== ''">{{currentUser.userData.addressZip}} {{currentUser.userData.addressLocation}}</p>
          </main>
        </template>
        <template v-else>
          <main class="account">
            <p id="user-name">
              <span>
                <input tabIndex="1" type="text" autocomplete="name" :placeholder="currentUser.userData.userName" v-model="newUserData.userName" maxlength="40" /><button v-if="currentUser.userData.userName !== ''" @click="deleteData('userName')"></button>
              </span>
            </p>
            <p id="company-name">
              <span>
                <input tabIndex="2" type="text" autocomplete="company" :placeholder="currentUser.userData.companyName" v-model="newUserData.companyName" maxlength="60" /><button v-if="currentUser.userData.companyName !== ''" @click="deleteData('companyName')"></button>
              </span>
            </p>
            <p id="company-legal">
              <span>
                <input tabIndex="3" type="text" autocomplete="company-2" :placeholder="currentUser.userData.companyLegal" v-model="newUserData.companyLegal" maxlength="20" /><button v-if="currentUser.userData.companyLegal !== ''" @click="deleteData('companyLegal')"></button>
              </span>
            </p>
            <p id="mail">
              <span>
                <input tabIndex="4" type="email" autocomplete="email" :placeholder="currentUser.userData.mail" v-model="newUserData.mail" maxlength="40" />
              </span>
            </p>
            <p id="phone">
              <span>
                <input tabIndex="5" type="tel" autocomplete="tel" :placeholder="currentUser.userData.phone" v-model="newUserData.phone" maxlength="20" /><button v-if="currentUser.userData.phone !== ''" @click="deleteData('phone')"></button>
              </span>
            </p>
            <p id="address-street">
              <span>
                <input tabIndex="6" type="text" autocomplete="address-line1" :placeholder="currentUser.userData.addressStreet" v-model="newUserData.addressStreet" maxlength="40" /><button v-if="currentUser.userData.addressStreet !== ''" @click="deleteData('addressStreet')"></button>
              </span>
            </p>
            <p id="address-addition">
              <span>
                <input tabIndex="7" type="text" autocomplete="address-line2" :placeholder="currentUser.userData.addressAddition" v-model="newUserData.addressAddition" maxlength="40" /><button v-if="currentUser.userData.addressAddition !== ''" @click="deleteData('addressAddition')"></button>
              </span>
            </p>
            <p id="address-zip">
              <span>
                <input tabIndex="8" type="text" autocomplete="address-line3" :placeholder="currentUser.userData.addressZip" v-model="newUserData.addressZip" maxlength="5" /><button v-if="currentUser.userData.addressZip !== ''" @click="deleteData('addressZip')"></button>
              </span>
            </p>
            <p id="address-location">
              <span>
                <input tabIndex="8" type="text" autocomplete="address-line4" :placeholder="currentUser.userData.addressLocation" v-model="newUserData.addressLocation" maxlength="30" /><button v-if="currentUser.userData.addressLocation !== ''" @click="deleteData('addressLocation')"></button>
              </span>
            </p>
          </main>
        </template>
        <aside v-if="loggedIn && !currentUser.verified">
          <button class="button account-button" @click="$root.sendVerificationMail()">Bestätigungsmail erneut senden</button>
        </aside>
      </section>
      <section class="tile">
        <header>
          <h2>Passwort</h2>
          <template v-if="currentUser.verified">
            <button v-if="!pwEdit" @click="togglePwEdit()">Bearbeiten</button>
            <span v-else class="button-group">
              <button @click="togglePwEdit()">Abbrechen</button>
              <button @click="updatePw()">Speichern</button>
            </span>
          </template>
        </header>
        <main class="account">
          <template v-if="!pwEdit">
            <p>**************</p>
          </template>
          <template v-else>
            <p id="current-password">
              <span>
                <input type="password" autocomplete="current-password" placeholder="***********" v-model="currentPw" maxlength="40" />
              </span>
            </p>
            <p id="new-password">
              <span>
                <input v-on:keyup.enter="updatePw()" type="password" autocomplete="new-password" placeholder="" v-model="newPw" maxlength="40" />
              </span>
            </p>
          </template>
        </main>
      </section>
    </div>
    <footer id="account-footer">
      <p>Zur Löschung Ihres Accounts senden Sie bitte eine E-Mail an {{supportMail}}. Ihrem Antrag auf Löschung Ihres Accounts wird schnellstmöglich innerhalb einer angemessenen Frist nachgekommen. Bitte beachten Sie, dass Sie ein Löschen des Accounts nicht von gegebenenfalls bestehenden Ansprüchen seitens clickzip befreit.</p>
    </footer>
    <how-to />
    <made />
    <transition name="fade" mode="out-in">
      <login-modal v-if="!loggedIn"></login-modal>
    </transition>
  </section>
</template>

<script>
import LoginModal from '@/components/LoginModal.vue'
import Hint from '@/components/Hint.vue'
import Made from '@/components/Made.vue'
import HowTo from '@/components/HowTo.vue'
export default {
  name: 'Account',
  components: {
    HowTo,
    Hint,
    Made,
    LoginModal
  },
  data: function () {
    return {
      pwEdit: false,
      currentPw: '',
      newPw: '',
      editMode: false,
      newUserData: null,
      tmpUserData: { // store data here if deleted (for cancelling)
        mail: '',
        companyName: '',
        companyLegal: '',
        userName: '',
        addressStreet: '',
        addressZip: '',
        addressLocation: '',
        addressAddition: '',
        phone: '',
        imgPath: ''
      }
    }
  },
  computed: {
    supportMail: function () {
      if (this.loggedIn) {
        return 'support' + '@' + 'clickzip' + '.de'
      } else {
        return 'none@clickzip.de'
      }
    },
    loggedIn: function () {
      return this.$root.loggedIn
    },
    currentUser: function () {
      return this.$root.currentUser
    }
  },
  methods: {
    togglePwEdit: function () {
      if (this.editMode) {
        this.toggleEditMode('cancel')
      }
      this.newPw = ''
      this.currentPw = ''
      this.pwEdit = !this.pwEdit
    },
    updatePw: function () {
      if (this.newPw.length > 5) {
        this.$root.setNewPassword(this.currentPw, this.newPw)
        this.togglePwEdit()
      } else {
        alert('Passwort zu kurz.')
      }
    },
    toggleEditMode: function (mode) {
      if (this.pwEdit) {
        this.togglePwEdit()
      }
      if (mode === 'cancel') { // if cancelling restore deleted data
        for (let [key, value] of Object.entries(this.tmpUserData)) { // compare each value
          if (value !== '') {
            this.currentUser.userData[key] = value
            this.tmpUserData[key] = ''
          }
        }
      }
      this.newUserData = {
        mail: '',
        companyName: '',
        companyLegal: '',
        userName: '',
        addressStreet: '',
        addressZip: '',
        addressLocation: '',
        addressAddition: '',
        phone: '',
        imgPath: ''
      }
      this.editMode = !this.editMode
    },
    updateProfile: function () {
      let changedSomething = false
      if (this.newUserData.mail !== '' && !this.validateEmail(this.newUserData.mail)) { // invalid mail
        alert('Bitte geben Sie eine gültige E-Mail-Adresse an')
        return
      } else if (this.newUserData.mail !== '') { // valid mail
        if (!this.newUserData.mail === this.currentUser.userData.mail) { // mail is different
          this.$root.setNewMail(this.newUserData.mail)
        }
      }
      // search for deletes
      for (let [key, value] of Object.entries(this.currentUser.userData)) { // compare each value
        if (this.currentUser.userData[key] === '' && this.tmpUserData[key] !== '') {
          console.log(key, value)
          changedSomething = true
        }
      }
      // search for changes
      for (let [key, value] of Object.entries(this.newUserData)) { // compare each value
        if (value !== '') {
          changedSomething = true
          this.currentUser.userData[key] = value
        }
      }
      if (changedSomething) {
        this.$root.updateProfile(this.currentUser.userData)
      }
      for (let [key, value] of Object.entries(this.tmpUserData)) { // reset tmpUserData
        if (value !== '') {
          this.tmpUserData[key] = ''
        }
      }
      this.toggleEditMode()
    },
    validateEmail: function (mail) {
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return true
      }
      return false
    },
    deleteData: function (key) {
      this.tmpUserData[key] = this.currentUser.userData[key] // save tmp
      this.currentUser.userData[key] = '' // delete
    }
  },
  watch: {
    loggedIn: function (online) { // cancel edit toggles on logut
      if (!online) {
        if (this.editMode) {
          this.toggleEditMode('cancel')
        }
        if (this.pwEdit) {
          this.togglePwEdit()
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/variables.scss";
#account {
  position: relative;
  height: 100%;
}
#pageContent {
  transition-duration: 0.2s;
  min-height: 100%;
}
.notLogged #pageContent {
  -webkit-backface-visibility: hidden;
  -webkit-perspective: 1000;
  -webkit-transform: translate3d(0,0,0);
  -webkit-transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000;
  transform: translate3d(0,0,0);
  transform: translateZ(0);
  filter: grayscale(1) blur(2px);
  opacity: 0.15;
}
h1 {
  font-family: $primaryFont;
  color: $secondaryHeadingColor;
  font-weight: $primaryFontBold;
  font-size: 22px;
  padding: 40px 15px 10px 15px;
}
.tile {
  margin: 0 15px 30px 15px;
  overflow: hidden;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.06);
  header {
    background: #fafafa;
    padding: 10px 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h2 {
      font-size: 22px;
      font-family: $primaryFont;
      font-weight: $primaryFontBold;
      color: $primaryFontColor;
      line-height: 1.1;
      margin: 0;
      hyphens: auto;
      width: 100%;
    }
    .button-group {
      display: flex;
      flex-direction: column-reverse;
    }
    button {
      @include backend-button();
    }
  }
  aside {
    padding: 24px 20px 20px 20px;
    border-top: 2px solid #F2F2F2;
    button {
      @include backend-button();
    }
  }
  main {
    padding: 20px 20px;
    font-family: $secondaryFont;
    font-weight: $secondaryFontNormal;
    &.account {
      p {
        display: flex;
        flex-direction: column;
        font-size: 16px;
        margin: 0 0 16px 0;
        &:before {
          font-size: 12px;
        }
        span {
          display: flex;
          align-items: center;
          input {
            width: 100%;
            border-radius: 0;
            border: none;
            outline: none;
            border-bottom: 1px solid #ddd;
            padding: 8px 0;
            line-height: 1;
            box-sizing: border-box;
          }
          button {
            border: none;
            outline: 0;
            -webkit-appearance: none;
            -moz-appearance: none;
            background: #fff;
            background: transparent;
            margin: 0 0 0 10px;
            width: 21px;
            min-width: 21px;
            height: 21px;
            background-image: url('../assets/img/icons/roundTrashBlue.svg');
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            opacity: 0.85;
            padding: 0;
            &:hover {
              cursor: pointer;
              opacity: 1;
            }
          }
        }
      }
      .primary-data {
        font-size: 24px;
        font-weight: $secondaryFontBold;
        margin-bottom: 0;
      }
      .secondary-data {
        font-size: 16px;
        color: $secondaryFontColor;
      }
      #user-name {
        &:before {
          content: 'Ihr Name'
        }
      }
      #company-name {
        &:before {
          content: 'Ihr Unternehmen'
        }
      }
      #company-legal {
        &:before {
          content: 'Rechtsform Ihres Unternehmens (z. B. GmbH, Einzelunternehmer)'
        }
      }
      #mail {
        &:before {
          content: 'Ihr E-Mail-Adresse'
        }
      }
      #phone {
        &:before {
          content: 'Ihre Telefonnummer'
        }
      }
      #address-street {
        &:before {
          content: 'Straße'
        }
      }
      #address-addition {
        &:before {
          content: 'Adresszusatz'
        }
      }
      #address-location {
        &:before {
          content: 'Ort'
        }
      }
      #address-zip {
        &:before {
          content: 'Postleitzahl'
        }
      }
      #verified {
        &:before {
          content: 'Verifizierter Nutzer'
        }
      }
      #current-password {
        &:before {
          content: 'Aktuelles Passwort'
        }
      }
      #new-password {
        &:before {
          content: 'Neues Passwort festlegen'
        }
      }
    }
  }
}
#account-footer {
  margin: 40px 15px 40px 15px;
  p {
    font-family: $secondaryFont;
    font-size: 14px;
    color: $secondaryFontColor;
  }
}
@media(min-width:360px) {
  h1 {
    font-size: 26px;
  }
}
@media(min-width:767px) {
  h1 {
    font-size: 32px;
    padding: 40px 40px 20px 40px;
  }
  .tile {
    margin: 0 40px 40px 40px;
    header {
      .button-group {
        flex-direction: row;
      }
    }
    main {
      &.account {
        p {
          span {
            input {
              width: 400px;
            }
          }
        }
      }
    }
    header {
      padding: 20px 20px;
    }
  }
  #account-footer {
    margin: 60px 40px 60px 40px;
  }
}
.fade-enter-active,
.fade-leave-active {
  position: relative;
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
